import React from 'react';

const PrivacyPolicy = () => {
  return (
    <div className="min-h-screen bg-gray-50 pt-24 pb-12">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="bg-white rounded-lg shadow-lg p-8">
          <h1 className="text-3xl font-bold text-gray-900 mb-8">Privacy Policy</h1>
          
          <div className="prose prose-lg max-w-none">
            <p className="text-sm text-gray-600 mb-8">
              <strong>Effective Date:</strong> August 2024
            </p>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">Who we are</h2>
              <p className="text-gray-700 leading-relaxed">
                CIVIONIKS CORP. ("Civioniks," "InfraHealth," "we") provides software and services for infrastructure health monitoring. This Privacy Policy explains how we collect, use, and protect personal and project data.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">Scope</h2>
              <ul className="list-disc pl-6 text-gray-700 space-y-2">
                <li>Our websites (e.g., civioniks.com, infrahealth.com.sa)</li>
                <li>SaaS applications, APIs, and dashboards</li>
                <li>Customer support channels</li>
              </ul>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">Data we collect</h2>
              <ul className="list-disc pl-6 text-gray-700 space-y-2">
                <li><strong>Account Data:</strong> name, role, email, login credentials.</li>
                <li><strong>Usage Data:</strong> device/browser, IP, logs, telemetry.</li>
                <li><strong>Project Data:</strong> infrastructure health monitoring data (strain, vibration, cracks, etc.). This is not personal medical data.</li>
                <li><strong>Transactional Data:</strong> billing contact info, payment confirmations (via PCI-compliant providers).</li>
                <li><strong>Support Data:</strong> messages, screenshots, attachments.</li>
              </ul>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">Why we use data</h2>
              <ul className="list-disc pl-6 text-gray-700 space-y-2">
                <li>Provide and operate infrastructure monitoring services.</li>
                <li>Improve safety, performance, and lifecycle management.</li>
                <li>Meet legal/regulatory obligations in GCC and other regions.</li>
              </ul>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">Sharing</h2>
              <ul className="list-disc pl-6 text-gray-700 space-y-2">
                <li>With vendors (hosting, analytics, support tools) under DPAs.</li>
                <li>With regulators when legally required.</li>
                <li>Never sold or shared for advertising.</li>
              </ul>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">International transfers</h2>
              <p className="text-gray-700 leading-relaxed mb-4">
                We comply with local laws for data residency:
              </p>
              <ul className="list-disc pl-6 text-gray-700 space-y-2">
                <li><strong>Saudi PDPL:</strong> Saudi-hosted storage available.</li>
                <li><strong>UAE DPL:</strong> cross-border rules observed.</li>
                <li><strong>EU/Canada:</strong> SCCs and PIPEDA compliance.</li>
              </ul>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">Retention</h2>
              <p className="text-gray-700 leading-relaxed">
                Project data retained only for contract duration or as required by law. Logs/backups subject to deletion schedules.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">Your rights</h2>
              <p className="text-gray-700 leading-relaxed">
                Depending on your jurisdiction: access, correction, deletion, restriction, portability, and objection. Contact hello@civioniks.com.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">Children</h2>
              <p className="text-gray-700 leading-relaxed">
                Not directed to children under 16.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">Contact</h2>
              <p className="text-gray-700 leading-relaxed">
                Privacy inquiries: hello@civioniks.com | Toronto, Canada
              </p>
            </section>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;